/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const CreateBatchSerializationPageContext = React.createContext({});
export let createBatchSerializationPageMachine: any;

const MODULE_NAME = 'machines.newBatchSerialization.createBatchSerialization';
const log: any = LoggerModule?.getInstance();

export const useSMCreateBatchSerialization = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  createBatchSerializationPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(createBatchSerializationPageMachine);

  return {
    createBatchSerializationPageMachine,
    createBatchSerializationState: state,
    createBatchSerializationSend: send,
  };
};
